export enum TypeDateEnum {
    START_DATE = 'Inicial',
    END_DATE = 'Final',
    CREATED_DATE = 'Criação',
}

export type TypeDate = 'START_DATE' | 'END_DATE' | 'CREATED_DATE';
